import { MAX_LICENSE_EXPIRATION } from '../../consts/license';

export const getLicenseExpiration = (expiration: number): number => {
  if (isNaN(expiration)) {
    return MAX_LICENSE_EXPIRATION;
  }

  return expiration;
};